// extracted by mini-css-extract-plugin
export default {"m":"_452472e5cb","title":"_9eb24274ed","feedback_inner_title":"_3e62de9c37","textarea":"_7b5c2f4775","radio":"d063697b5f","text":"_88b17738b2"};